module.exports = __webpack_public_path__ + "img/carrier-vodafone.550b741c.svg";